import { useLogicControlContext as C } from "./LogicControlContext.js";
import { createStrictContext as x } from "../../util/context/createStrictContext.js";
import * as E from "ramda";
import { useState as i, useCallback as s, useEffect as I } from "react";
import { useTranslation as b } from "react-i18next";
import { jsx as d } from "react/jsx-runtime";
let l = !1;
const [v, j] = x("Message"), w = (f) => {
  const {
    children: m
  } = f, {
    t: e
  } = b(), [p, c] = i(null), [u, g] = i(null), {
    generalError: r,
    setGeneralError: a
  } = C(), k = s(() => {
    l = !1, c(null);
  }, []), t = s((o) => {
    l || (l = E.propOr(!1, "blocking", o), c(o));
  }, []), n = s((o) => {
    t({
      title: e("common.popup.error"),
      message: o,
      confirm: e("common.popup.ok")
    });
  }, [t, e]);
  return I(() => {
    r && (n(r), a(null));
  }, [r, a, n]), /* @__PURE__ */ d(v, {
    value: {
      info: p,
      snackInfo: u,
      cleanInfo: k,
      setInfo: t,
      setSnackInfo: g,
      showGeneralError: n
    },
    children: m
  });
};
export {
  w as MessageProvider,
  j as useMessageContext
};
//# sourceMappingURL=MessageContext.js.map
